module.exports = __webpack_public_path__ + "static/bannerBg-1b093524baa6f8bd1f9e295f26d6ece8.png";